import './index.scss'

export interface Props {
    children: TChildren
    background?: boolean
    size?: 'small' | 'regular'
    onClick?: () => void
    className?: string
}

const Icon = ({ children, size = 'regular', onClick, className }: Props) => {
    const classes = ['asm-icon', size, className].filter(Boolean).join(' ')

    return (
        <i className={classes} onClick={onClick}>
            {children}
        </i>
    )
}

export default Icon
